import { Layout } from '@components/Layout';
import PermissionGate from '@components/upercut-permissions/PermissionGate';
import { UpercutManagement } from '@modules/upercut';
import { Route, Routes } from 'react-router-dom';
import CreateUpercutPage from './CreateUpercutPage';
import EditUpercutPage from './EditUpercutPage';
import RoleManagement from './RoleManagement';

const UpercutPage = () => {
    return (
        <Layout
            breadcrumbs={[
                { label: 'Tableau de bord', href: '/', value: 'dashboard' },
                { label: 'Gestion des utilisateurs Upercut', href: '/upercuts', value: 'upercuts' },
                { label: 'Gestion des rôles', href: '/upercuts/roles', value: 'roles' },
                { label: 'Créer un utilisateur', href: '/upercuts/create', value: 'create' },
                { label: 'Modifier un utilisateur', href: '/upercuts/:id/edit', value: 'edit' },
            ]}
            heading="Gestion des utilisateurs Upercut"
        >
            <Routes>
                <Route
                    path="/"
                    element={
                        <PermissionGate permission="users:manage">
                            <UpercutManagement />
                        </PermissionGate>
                    }
                />
                <Route
                    path="/create"
                    element={
                        <PermissionGate permission="users:manage">
                            <CreateUpercutPage />
                        </PermissionGate>
                    }
                />
                <Route
                    path="/:id/edit"
                    element={
                        <PermissionGate permission="users:manage">
                            <EditUpercutPage />
                        </PermissionGate>
                    }
                />
                <Route
                    path="/roles"
                    element={
                        <PermissionGate permission="system:manage">
                            <RoleManagement />
                        </PermissionGate>
                    }
                />
            </Routes>
        </Layout>
    );
};


export default UpercutPage;
